import React from 'react'

import LocationPage from './LocationPage'
import TemporarySolutionPage from './TemporarySolutionPage'
import BookTestWrapper from './BookTest.wrapper'

export interface BookTestRoutingParams {
  locationUrlKey: string
  productUrlKey: string
}

const BookTestRouting = [
  {
    children: [
      {
        element: <LocationPage />,
        path: '',
      },
    ],
    element: <BookTestWrapper />,
    path: 'pick-slot',
  },
  {
    element: (<TemporarySolutionPage />),
    path: 'not-found',
    public: true,
  },
]

export default BookTestRouting
